import { render } from "./pageShow.vue?vue&type=template&id=4048e8bc&scoped=true"
import script from "./pageShow.vue?vue&type=script&lang=js"
export * from "./pageShow.vue?vue&type=script&lang=js"

import "./pageShow.vue?vue&type=style&index=0&id=4048e8bc&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.2.13_webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4048e8bc"]])

export default __exports__